import { commonServerInstance, downloadInstance } from '@/utilities/instances'
import { downloadFile } from './common'

export function getSettlementCustomers() {
  return commonServerInstance
    .get('/settlement/getallcustomer')
    .then(({ data }) => data.data)
}

export function getSettlementStatus() {
  return commonServerInstance
    .get('/settlement/status')
    .then(({ data }) => data.data)
}

export function searchSettlementProcedures(params: any) {
  return commonServerInstance
    .get('/settlement/settlementprocedure', {
      params
    })
    .then(({ data }) => data.data)
}
export const downloadPreauditFile = async (params: any) => {
  const response = await downloadInstance.post(
    `/settlement/downloadpreauditfile`,
    { ...params }
  )
  return await downloadFile(response, params.file_name)
}

export const downloadQCPostAuditFile = async (params: any) => {
  const response = await downloadInstance.post(
    `/settlement/downloadqcpostauditfile`,
    { ...params }
  )
  return await downloadFile(response, params.file_name)
}

export const downloadPriceCardFile = async (params: any) => {
  const response = await downloadInstance.post(
    '/settlement/downloadpricecard',
    { ...params }
  )
  return await downloadFile(response, params.file_name)
}

export const downloadAdjustFile = async (params: any) => {
  const response = await downloadInstance.post(
    '/settlement/downloadadjustfile',
    { ...params }
  )
  return await downloadFile(response, params.file_name)
}

export const deleteAdjustFile = async (params: any) => {
  const response = await commonServerInstance.post(
    '/settlement/deleteadjustfile',
    { ...params }
  )
  return response.data.data
}

export const downloadAdjustTemplate = async () => {
  const response = await downloadInstance.post('/settlement/downloadtemplate')
  return await downloadFile(response, 'template.xlsx')
}

export const uploadAdjustFile = async (formData: any) => {
  const response = await commonServerInstance.post(
    '/settlement/uploadadjustfile',
    formData
  )
  return response.data.data
}

export const qcApproval = async (params: any) => {
  const response = await commonServerInstance.post(
    '/settlement/qcapprovestatement',
    { ...params }
  )
  return response.data.data
}

export const getInvoicePreview = async (params: any) => {
  const response = await commonServerInstance.post(
    '/settlement/invoicepreview',
    { billing_num: params.billing_num }
  )
  return response.data.data
}

export const getInvoice = async (params: any) => {
  const response = await downloadInstance.post('/settlement/getinvoice', {
    billing_num: params.billing_num
  })
  const contentType = response.headers['content-type']
  if (contentType !== 'application/json') {
    const fileUrl = window.URL.createObjectURL(
      new Blob([response.data], { type: 'application/pdf;base64' })
    )
    return fileUrl
  } else {
    throw new Error('File not found or failed downloading')
  }
}

export const resetSettlementStatus = async (params: any) => {
  const response = await commonServerInstance.post('/settlement/resetstatus', {
    ...params
  })
  return response.data.data
}

export const downloadInvoiceRecords = async (params: {
  billing_nums: string
}) => {
  const response = await downloadInstance.post(
    '/settlement/download-invoice-records',
    { ...params }
  )
  return await downloadFile(response)
}
